import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Planner from  '@/components/page/Planner';
import PlannerContext from '@/context/PlannerContext';

class PlannerPortal extends Component {
  render() {

    let minTimeInMinutes: number
    // Container ref
    const targetContainer = document.getElementById('react-planner-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }
    else {
      minTimeInMinutes = +targetContainer.getAttribute('data-plannerEventIntervalInMinutes');
    }

    return ReactDOM.createPortal(
      <PlannerContext minimumEventTime={minTimeInMinutes}>
        <Planner />
      </PlannerContext>
      , targetContainer
    );
  }
}

export default PlannerPortal;